import React, { useState } from "react";

function AboutUs() {
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <div className="text-white">
      <div
        className="position-relative"
        style={{
          height: "600px",
          backgroundColor: "#999",
          overflow: "hidden",
        }}
      >
        <img
          src="/images/aboutus-banner2.jpg"
          alt="About Us Banner"
          onLoad={handleImageLoad}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            position: "absolute",
            top: 0,
            left: 0,
            opacity: imageLoaded ? 1 : 0,
            transition: "opacity 0.8s ease-in-out",
            zIndex: 0,
          }}
        />

        <div
          className="position-absolute w-100 h-100"
          style={{
            top: 0,
            left: 0,
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 1,
          }}
        />

        <div
          className="position-absolute top-50 start-50 translate-middle text-center"
          style={{
            maxWidth: "800px",
            padding: "20px",
            zIndex: 2,
            color: "#fffcf5",
          }}
        >
          <h1
            className="fw-bold display-5"
            style={{
              textShadow: "2px 2px 6px rgba(0, 0, 0, 0.7)",
            }}
          >
            About Us
          </h1>
          <p
            className="mt-3"
            style={{
              fontWeight: 600,
              textShadow: "1px 1px 4px rgba(0, 0, 0, 0.5)",
            }}
          >
            We encourage you to work with PSR-IT—your trusted partner for IT
            services, BPO, and staffing solutions.
          </p>
        </div>
      </div>

      <div className="container-fluid px-0">
        <div className="row g-0 d-flex align-items-stretch">
          <div
            className="col-md-6 p-5 d-flex flex-column"
            style={{ backgroundColor: "#2c2c2c", minHeight: "100%" }}
          >
            <div className="flex-grow-1 d-flex flex-column justify-content-start">
              <h3
                className="text-center mb-3"
                style={{ color: "#ffcccb", fontWeight: "600" }}
              >
                Our Mission
              </h3>
              <p
                style={{
                  lineHeight: "1.6",
                  fontWeight: "400",
                  maxWidth: "90%",
                  margin: "0 auto",
                }}
              >
                PSRIT is not just a service provider—we are your trusted partner
                with proven expertise in IT solutions, BPO, and staffing
                services. We deliver high-impact, results-driven services that
                help your organization stay ahead of the competition.
                <br />
                <br />
                Our mission is to empower businesses with scalable, innovative,
                and customer-focused IT and workforce solutions. We believe in
                fostering long-term partnerships by understanding our clients’
                unique challenges and helping them adapt to the rapidly evolving
                digital world.
              </p>
            </div>
          </div>
          <div
            className="col-md-6 p-5 d-flex flex-column"
            style={{ backgroundColor: "#39414a", minHeight: "100%" }}
          >
            <div className="flex-grow-1 d-flex flex-column justify-content-start">
              <h3
                className="text-center mb-3"
                style={{ color: "#b2f5ea", fontWeight: "600" }}
              >
                Our IT Services
              </h3>
              <p
                style={{
                  lineHeight: "1.6",
                  fontWeight: "400",
                  maxWidth: "90%",
                  margin: "0 auto",
                }}
              >
                Our expert team offers a wide range of services to optimize your
                IT infrastructure. By staying on the cutting edge of
                technological advancements, we ensure your business is always
                equipped with the most effective and efficient solutions
                available.
              </p>
              <ul
                style={{
                  lineHeight: "1.8",
                  paddingLeft: "40px",
                  maxWidth: "90%",
                  margin: "0 auto",
                }}
              >
                <li>Web Development</li>
                <li>Web-enabled and Web-based Applications</li>
                <li>Enterprise Resource Planning</li>
                <li>
                  Up-gradation, Migration and Integration of existing
                  applications
                </li>
                <li>Customer Relationship Management</li>
                <li>
                  Business Intelligence systems – reports, analytics, and
                  dashboards
                </li>
                <li>Software Testing and Quality assurance</li>
                <li>Creative Services – Website, Logo, Brochure design</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-black text-white py-5 px-4">
        <div className="container">
          <h2 className="fw-bold text-center text-info">
            Comprehensive Staffing Solutions
          </h2>
          <p className="mt-3">
            Let us talk about your staffing needs. We recognize that talent is
            one of your most valuable assets. That’s why our staffing services
            are designed to provide access to top-tier professionals who not
            only possess the right technical skills but also align with your
            company’s culture.
          </p>
          <p>
            We help you find the right fit for your project. Reach out to us at{" "}
            <strong>sales@psritservices.com</strong> or{" "}
            <strong>(+91) 8143964374</strong> for long-term success.
          </p>
        </div>
      </div>

      <div className="bg-light text-dark py-5 px-4">
        <div className="container">
          <h2 className="fw-bold text-center text-maroon">Why Choose Us?</h2>
          <p className="mt-3">
            We are deeply invested in your business’s success, which is why we
            take the time to understand your unique needs, challenges, and
            long-term objectives.
          </p>
          <ul className="mt-3 fs-5">
            <li>
              <strong>Client-Centric Focus:</strong> We put your needs first,
              ensuring our solutions are tailored to fit your business goals.
            </li>
            <li>
              <strong>Innovative Solutions:</strong> We stay at the forefront of
              technology, constantly evolving our services to offer cutting-edge
              IT and staffing solutions that drive business growth.
            </li>
            <li>
              <strong>Dedicated Partnership:</strong> We’re here for the long
              haul, offering proactive, ongoing support.
            </li>
            <li>
              <strong>Proven Track Record:</strong> A history of successful IT
              projects and placements that make a measurable difference.
            </li>
            <li>
              <strong>Customized solutions:</strong> Our team works closely with
              you to deliver customized solutions that align with your goals and
              drive meaningful results.
            </li>
            <li>
              <strong>Top Talent:</strong> Our recruitment process ensures you
              receive highly qualified candidates who are a perfect fit for your
              business.
            </li>
          </ul>
        </div>
      </div>

      <div className="bg-dark text-center py-5">
        <h3 className="text-info">
          Looking to maximize productivity? Look no further!
        </h3>
        <p className="fs-5">
          Let’s Take Your Business to the Next Level! We’re ready to partner
          with you to drive real, lasting change. Whether you need expert IT
          services or top talent to fuel your success, we’re here to help.
        </p>
      </div>
    </div>
  );
}

export default AboutUs;
